import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import PageTitle from '../Components/Common/PageTitle';
import Btn from '../Components/Common/Btn';
import Delete from '../Assets/Icons/Delete.svg';
import './Gallery.css'
import { supabase } from '../supabase';

const Gallery = () => {

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const fetchImages = async () => {
        try {
            setLoading(true);
            const { data, error } = await supabase
                .from('gallery')
                .select('*')
                .order('created_at', { ascending: false });

            if (error) throw error;
            setImages(data || []);
        } catch (error) {
            console.error("Error loading gallery data assets:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const handleDeleteImage = async (id) => {
        if (window.confirm("Are you sure you want to permanently remove this image from the showroom gallery?")) {
            const { error } = await supabase
                .from('gallery')
                .delete()
                .eq('id', id);

            if (error) {
                console.error("Failed structural deletion execution:", error);
                alert("Failed to delete asset image reference details.");
            } else {
                fetchImages(); 
            }
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImageFile(e.target.files[0]);
        }
    };

    const handleImageUpload = async (e) => {
        e.preventDefault();
        if (!imageFile) return alert("Please pick an image file first!");

        setUploading(true);

        try {

            const fileExt = imageFile.name.split('.').pop();
            const fileName = `${Math.random()}.${fileExt}`;
            const filePath = `gallery/${fileName}`; 


            const { error: uploadError } = await supabase.storage
                .from('Evs_Imgs')
                .upload(filePath, imageFile);

            if (uploadError) throw uploadError;


            const urlResponse = supabase.storage.from('Evs_Imgs').getPublicUrl(filePath);
            const publicImageUrl = urlResponse.data?.publicUrl || urlResponse.publicUrl || '';


            const { error: insertError } = await supabase
                .from('gallery')
                .insert([{ img_url: publicImageUrl }]);

            if (insertError) throw insertError;


            setImageFile(null);
            setIsModalOpen(false);
            fetchImages(); 

        } catch (error) {
            console.error("Upload transaction crashed:", error);
            alert("Failed to sync media layout asset: " + error.message);
        } finally {
            setUploading(false);
        }
    };

    return ( 
        <main className='gallery'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <div className='PageHeader'>
                        <PageTitle TitleText='Gallery' SubText='Manage and curate high-resolution visual assets from the 2024 Electrify Egypt Summit.' HeaderBtnsClass='NoHeaderBtns'/>
                        <Btn BtnStyle='AddBtn' BtnText='Add Image' onClick={() => setIsModalOpen(true)}/>
                    </div>

                    {loading ? (
                        <div className="GridLoader" style={{color: '#56FF50', padding: '40px', textAlign: 'center'}}>
                            Fetching Visual Assets...
                        </div>
                    ) : (
                        <div className="DashboardImageGrid">
                            {images.map((item) => (
                                <div key={item.id} className="DashboardImageCard">
                                    <div className="ImageWrapper">
                                        <img src={item.img_url} alt="Showroom Asset View" className="DashboardGridImage" />
                                    </div>
                                    <div className="ImageCardActions">
                                        <button className="DeleteAssetBtn" onClick={() => handleDeleteImage(item.id)}>
                                            <img src={Delete} alt="" />
                                            <span>Delete Asset</span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                </div>

                 
            </div>

            {isModalOpen && (
                <div className="BookingModalOverlay">
                    <div className="BookingModalContent">
                        <h3>Upload New Event Image</h3>
                        <p className="ModalAttendeeSub">PNG, JPG, or WEBP asset files hosted securely via Supabase Cloud Bucket Storage pipelines.</p>

                        <form onSubmit={handleImageUpload}>
                            <div className="FormGroup">
                                <label>Select Image File</label>
                                <input 
                                    type="file" 
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    required
                                    style={{ padding: '20px', border: '2px dashed #444', background: '#16161a', cursor: 'pointer' }}
                                />
                                {imageFile && (
                                    <p style={{ fontSize: '12px', color: '#56FF50', marginTop: '5px' }}>
                                        ✓ Ready: {imageFile.name} ({(imageFile.size / 1024 / 1024).toFixed(2)} MB)
                                    </p>
                                )}
                            </div>

                            <div className="ModalActions">
                                <button 
                                    type="button" 
                                    className="CancelBtn" 
                                    onClick={() => { setIsModalOpen(false); setImageFile(null); }}
                                    disabled={uploading}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    className="SaveBtn"
                                    disabled={uploading}
                                    style={{ background: uploading ? '#444' : '#56FF50', color: uploading ? '#aaa' : '#000' }}
                                >
                                    {uploading ? 'Streaming...' : 'Upload Media'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </main>
     );
}
 
export default Gallery;